import * as Zod from 'zod';

export const ticketStatusScheme = Zod.object({
  id: Zod.string(),
  label: Zod.string(),
});
